import { useEffect, useState } from 'react';

import BreadcrumbComponent from '@/components/breadcrumb';
import AddRoomDialog from '@/components/dialogs/rooms/add-room';
import RoomCard from '@/components/rooms/card';
import FilterRooms from '@/components/rooms/filter';
import { useMainContext } from '@/context/main-context';

function Rooms() {
  const { rooms } = useMainContext();
  const [filteredRooms, setFilteredRooms] = useState(rooms);
  const [filterOption, setFilterOption] = useState('name');
  const [searchTerm, setSearchTerm] = useState('');
  const [addRoomDialog, setAddRoomDialog] = useState(false);

  console.log(rooms);

  useEffect(() => {
    const handler = setTimeout(() => {
      const newFilteredRooms = rooms.filter((room) => {
        switch (filterOption) {
          case 'name':
            return room.name.toLowerCase().includes(searchTerm.toLowerCase());
          case 'capacity':
            return room.capacity.toString().includes(searchTerm);
          default:
            return true;
        }
      });
      setFilteredRooms(newFilteredRooms);
    }, 300);

    return () => clearTimeout(handler);
  }, [searchTerm, filterOption, rooms]);

  return (
    <div className="px-4 lg:px-8 my-4 space-y-4">
      <BreadcrumbComponent title="Xonalar ro'yxati" />

      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">Mavjud xonalar</h2>
          <p className="text-muted-foreground">
            O‘quv markazda mavjud bo‘lgan xonalar ro‘yxati.
          </p>
        </div>
      </div>

      <AddRoomDialog open={addRoomDialog} setOpen={setAddRoomDialog} />

      <FilterRooms
        title="Xona qo'shish"
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        filterOption={filterOption}
        setFilterOption={setFilterOption}
        setAddRoomDialog={setAddRoomDialog}
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredRooms.map((room) => (
          <RoomCard key={room.id} room={room} />
        ))}
      </div>
    </div>
  );
}

export default Rooms;
